// extracted by mini-css-extract-plugin
export default {"login_bg":"login_login_bg__b74Zi","login_submit":"login_login_submit__w9l7M"};